import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { ComingSoonPage } from "./pages/ComingSoonPage";
import { WorkOrdersPage } from "./pages/WorkOrdersPage";
import { WorkOrderDetailPage } from "./pages/WorkOrderDetailPage";
import { NewWorkOrderPage } from "./pages/NewWorkOrderPage";
import { MaintenanceWorkOrdersPage } from "./pages/MaintenanceWorkOrdersPage";
import { MaintenanceCalendarPage } from "./pages/MaintenanceCalendarPage";
import { MaintenanceWorkOrderPage } from "./pages/MaintenanceWorkOrderPage";
import { InventoryPage } from "./pages/InventoryPage";
import { NewInventoryItemPage } from "./pages/NewInventoryItemPage";
import { InventoryItemPage } from "./pages/InventoryItemPage";
import { LeadsPage } from "./pages/LeadsPage";
import { NewLeadPage } from "./pages/NewLeadPage";
import { LeadDetailPage } from "./pages/LeadDetailPage";
import { UnitsPage } from "./pages/UnitsPage";
import { UnitDetailPage } from "./pages/UnitDetailPage";
import { TenantsPage } from "./pages/TenantsPage";
import { NewTenantPage } from "./pages/NewTenantPage";
import { TenantDetailPage } from "./pages/TenantDetailPage";
import { RemoveTenantPage } from "./pages/RemoveTenantPage";
import { EvictionListPage } from "./pages/EvictionListPage";
import { IncidentsPage } from "./pages/IncidentsPage";
import { NewIncidentPage } from "./pages/NewIncidentPage";
import { IncidentDetailPage } from "./pages/IncidentDetailPage";
import { AdminPage } from "./pages/AdminPage";
import { NewUserPage } from "./pages/NewUserPage";
import { UserDetailPage } from "./pages/UserDetailPage";
import { AlertsPage } from "./pages/AlertsPage";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import { useAuth } from "./auth/AuthProvider";
import { homePathForRole } from "./lib/routes";

export function App() {
  const { user, isLoading } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      {/* Management / Staff routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/work-orders"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <WorkOrdersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/work-orders/new"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <NewWorkOrderPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/work-orders/:id"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <WorkOrderDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventory"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <InventoryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventory/new"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <NewInventoryItemPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventory/:id"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <InventoryItemPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/leads"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <LeadsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/leads/new"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <NewLeadPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/leads/:id"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <LeadDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/units"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <UnitsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/units/:id"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <UnitDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tenants"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <TenantsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tenants/new"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <NewTenantPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tenants/:id"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <TenantDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tenants/:id/remove"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <RemoveTenantPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/eviction-list"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <EvictionListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/incidents"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <IncidentsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/incidents/new"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <NewIncidentPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/incidents/:id"
        element={
          <ProtectedRoute roles={["management", "staff"]}>
            <IncidentDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute roles={["management"]}>
            <AdminPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/new"
        element={
          <ProtectedRoute roles={["management"]}>
            <NewUserPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/:id"
        element={
          <ProtectedRoute roles={["management"]}>
            <UserDetailPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/alerts"
        element={
          <ProtectedRoute>
            <AlertsPage />
          </ProtectedRoute>
        }
      />

      {/* Maintenance routes */}
      <Route
        path="/maintenance"
        element={
          <ProtectedRoute roles={["maintenance"]}>
            <MaintenanceWorkOrdersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/maintenance/calendar"
        element={
          <ProtectedRoute roles={["maintenance"]}>
            <MaintenanceCalendarPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/maintenance/:id"
        element={
          <ProtectedRoute roles={["maintenance"]}>
            <MaintenanceWorkOrderPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/account"
        element={
          <ProtectedRoute>
            <ComingSoonPage title="Account" ships="v0.5" />
          </ProtectedRoute>
        }
      />

      {/* Root + 404 → role-aware redirect (or login when unauthenticated). */}
      <Route
        path="*"
        element={
          isLoading ? null : user ? (
            <Navigate to={homePathForRole(user.role)} replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
    </Routes>
  );
}
